export enum DietType {
  Standard = null,
  Vegan = 1,
  Vegetarian = 2,
}
